import React, { useEffect, useRef } from "react";


const ColorPicker = ({value, onChange, inputProps = {}}) => {
  const inputRef = useRef();

  useEffect(() => {
    const inputInstance = jQuery(inputRef.current)
    inputInstance.colorpicker();

    inputInstance.on('hidePicker', (e) => onChange(e.color.toHex()))
    return () => {
      inputInstance.off('hidePicker')
      inputInstance.colorpicker('destroy');
    }
  }, [onChange])


  return <input 
    ref={inputRef} 
    type='text' 
    className='form-control'
    value={value} 
    onChange={(e) => onChange(e.target.value)}
    {...inputProps}
  />
}

export default ColorPicker;